<div class="form-group">
    <label [for]="id">{{title}} {{control | controlRequiredText}}</label>

    <input-date [control]="control" [id]="id" [title]="title" [minDate]="minDate" [maxDate]="maxDate"
        [minYear]="minYear" [maxYear]="maxYear" [startView]="startView" [placeholder]="placeholder"
        [messageRequired]="messageRequired" [messageFooter]="messageFooter" ></input-date>

</div>